import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Cookies from 'js-cookie'
// import axios from 'axios'
import axios from '@/axiosLoading/axios' //Loading
import VueAxios from 'vue-axios' //Loading
import Loading from 'vue-loading-overlay' //Loading
import 'vue-loading-overlay/dist/vue-loading.css' //Loading

Vue.prototype.$axios = axios
Vue.use(VueAxios, axios) //Loading
Vue.component('Loading', Loading); //Loading

//router
router.beforeEach(function (to, from, next) {
  // chrome頁面置頂
  // console.log(document.body.scrollTop);
  document.body.scrollTop = 0;
  // firefox頁面置頂
  document.documentElement.scrollTop = 0;
  // safari頁面置頂
  window.pageYOffset = 0;
  switch (to.name) {
    case 'MemberHome':
    case 'AddOtherUsers':
    case 'AddStoredValue':
    case 'TenantFeedback':
    case 'TenantPaymentContent':
      if (localStorage.getItem('house_number') != null) {
        if (localStorage.getItem('house_number') && localStorage.getItem('DiagnosticTest')) {
          const oVerify = new FormData();
          oVerify.append('CMD', 'LoginFromVerify');
          oVerify.append('house_number' , localStorage.getItem('house_number'));
          oVerify.append('DiagnosticTest', localStorage.getItem('DiagnosticTest'));
          axios.post(process.env.VUE_APP_FROENT_API_PREFIX, oVerify)
          .then(response => {
              // console.log(response);
              const data = response.data;
              if (data.result != true) {
                localStorage.removeItem('house_number');
                localStorage.removeItem('DiagnosticTest');
                alert(data.result);
                location.reload();
              } else {
                next();
              }
          })
          .catch(error => {
              console.log(error);
          })
        } else {
          next({name:'Login'});
        }
      } else {
        next({name:'Login'});
      }
      break;
    default:
        next();
  }
  // next();
});
//swiper輪播
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)


Vue.prototype.$cookies = Cookies;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
